export enum FAQLoginEnum{
    PostLoginId=1,
    PreLoginId=2
}